export const TOGGLE_SIDEBAR = '[Main] TOGGLE_SIDEBAR'
export type TOGGLE_SIDEBAR = typeof TOGGLE_SIDEBAR

export const SET_ACTIVE_MENU_ITEM = '[Main] SET_ACTIVE_MENU_ITEM'
export type SET_ACTIVE_MENU_ITEM = typeof SET_ACTIVE_MENU_ITEM

export const SET_ACTIVE_SUB_MENU_ITEM = '[Main] SET_ACTIVE_SUB_MENU_ITEM'
export type SET_ACTIVE_SUB_MENU_ITEM = typeof SET_ACTIVE_SUB_MENU_ITEM

export const SET_ACTIVE_DROPDOWN_MENU_ITEM = '[Main] SET_ACTIVE_DROPDOWN_MENU_ITEM'
export type SET_ACTIVE_DROPDOWN_MENU_ITEM = typeof SET_ACTIVE_DROPDOWN_MENU_ITEM

export const SET_FORM_OPEN = '[Main] SET_FORM_OPEN'
export type SET_FORM_OPEN = typeof SET_FORM_OPEN

export const SET_FORM_DIRTY= '[Main] SET_FORM_DIRTY'
export type SET_FORM_DIRTY = typeof SET_FORM_DIRTY

export const OPEN_CONFIRM_MODAL = '[Main] OPEN_CONFIRM_MODAL'
export type OPEN_CONFIRM_MODAL = typeof OPEN_CONFIRM_MODAL
